import { Controller } from 'stimulus';

import { rowFilterService } from '../libs/row_filter_service';

export default class extends Controller {
  toggle() {
    let element = this.element.querySelector('span:last-child');

    rowFilterService.updateFilter(
      this.data.get('columnIndex'),
      this.element.textContent,
      element,
    );
  }
}
